// 消息类型
export const messageTypeMap = [['UN_READ', 'unread'], ['READ', 'read']]

// English native speaker映射
export const EnglishSpeakerEnMap = [[0, 'Yes'], [1, 'No']]
// Speak Chinese映射
export const SpeakChineseEnMap = [[0, 'Yes'], [1, 'No']]
// Degree映射
export const degreeEnMap = [
  ['PHD', 'PhD'],
  ['MASTER', 'Master'],
  ['DPHILL', 'DPhill'],
  ['MPHILL', 'MPhill'],
  ['MSC', 'MSc'],
  ['MSA', 'MSa'],
  ['JD', 'JD'],
  ['MD', 'MD'],
  ['BACHELOR_DEGREE', 'Bachelor Degree'],
  ['OTHER', 'Other']
]

// Payment
// Chinese Citizen映射
export const isChineseCitizenEnMap = [[0, 'Yes'], [1, 'No']]
// Payment method映射
export const PaymentMethodEnMap = [
  ['PAYPAL', 'Paypal'],
  ['INLAND', 'InlandBank']
]
// Account Currency映射
export const AccountCurrencyEnMap = [
  ['USD', 'USD'],
  ['GBP', 'GBP'],
  ['HKD', 'HKD'],
  ['CNY', 'CNY']
]

// 时区映射
export const zoneEnMap = [
  {
    value: 'AEST',
    title: 'Australian Eastern Standard Time'
  },
  {
    value: 'ACST',
    title: 'Australian Central Standard Time'
  },
  {
    value: 'AWST',
    title: 'Australian Central Western Standard Time'
  },
  {
    value: 'BJT',
    title: 'Beijing Time'
  },
  {
    value: 'EST',
    title: 'US Eastern Time'
  },
  {
    value: 'MST',
    title: 'US Mountain Time'
  },
  {
    value: 'CST',
    title: 'US Central Time'
  },
  {
    value: 'PST',
    title: 'US Pacific Time'
  },
  {
    value: 'SAST',
    title: 'South Africa Time'
  },
  {
    value: 'BST',
    title: 'British Time'
  },
  {
    value: 'FST',
    title: 'French Time'
  },
  {
    value: 'TST',
    title: 'Thailand Time'
  }
]
